"use client";
import { cn } from "utils";
import { useSearchParams } from "next/navigation";
import { useSnapshot } from "valtio";
import { useEffect, useMemo } from "react";
import { deviceDetector } from "@ospweb/sdk-ui";
import { ChatEntry } from "../../ChatEntry";
import { ShowOnPcOrMobile } from "../../ShowOnPcOrMobile";
import EdgenDrawerCallable from "../../EdgenDrawerCallable";
import { CoPilotTab } from "./CoPilotTab";
import Translations from "@translate/components/CoPilot/CopilotHeader/CopilotHeader";
import { I18nUtil } from "@utils/i18n";
import { usePathname } from "@hooks/usePathname";
import { ROUTER_PATH } from "@/src/config/router";
// import { useUserFavoriteAssets } from "@/src/hooks";
import { HomeStore } from "@/src/store/modules/home";
import { LOCAL_STORAGE_KEYS } from "@/src/config";
import { useGlobalReportManager } from "@/src/hooks/useGlobalReportManager";
import { ChatStore } from "@/src/store";
import { useIsPc } from "@/src/hooks";
import { Back } from "@/src/components/mainHeader/Back";

const I18n = I18nUtil.createScoped(Translations);

// 2026-01-20 注：这个文件目前阶段仅在portfolio页面使用
export const CopilotHeader = () => {
  const pathname = usePathname();
  const [isPC] = useIsPc();
  const searchParams = useSearchParams();

  const isNotShowHeader = [ROUTER_PATH.CO_PILOT].includes(pathname);
  // const { hasAssets } = useUserFavoriteAssets();
  const { isOpen } = useSnapshot(HomeStore);
  useGlobalReportManager();
  useEffect(() => {
    const removeChatStore = () => {
      localStorage.removeItem(LOCAL_STORAGE_KEYS.CHAT_ID);
      ChatStore.loading = false;
      ChatStore.hasChatModal = false;
    };
    // 初始化清除对话
    isPC && removeChatStore();
    return () => {
      if (!isPC) {
        return;
      }
      EdgenDrawerCallable.end(false);
      removeChatStore();
    };
  }, [isPC]);

  const isPortfolioDetail = useMemo(() => {
    return pathname.includes("portfolio") && searchParams.get("assetType");
  }, [pathname, searchParams]);

  if (isNotShowHeader || isPortfolioDetail) {
    return <></>;
  }

  return (
    <>
      <div
        className={cn(
          "sticky top-0 w-full z-100 flex flex-col bg-background_solid_secondary",
          !isOpen && "md:w-[calc(100%-64px)]",
        )}
      >
        {deviceDetector.isMobile() && (
          <header
            aria-label="Copilot Header header"
            data-openreplay-label="Copilot Header header Semantic"
            id="sem-copilot-header-header"
            className="h-[56px] flex items-center gap-2 px-4 md:hidden"
          >
            <Back />
            <span className="headline_regular_s font-bold text-content_primary">
              {I18n.t("Portfolio")}
            </span>
          </header>
        )}
        <CoPilotTab className={cn("flex-1 pl-4 md:flex")} />
      </div>
      <ShowOnPcOrMobile showMode="pc">
        <ChatEntry />
      </ShowOnPcOrMobile>
    </>
  );
};
